import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { isEmbedded } from '../embed';

/**
 * Keeps the current URL query string when navigating between chat (/, or /embed in the website widget) and privacy (/privacy).
 */
export function usePreserveSearch() {
   const { search } = useLocation();

   return useMemo(
      () => ({
         search,
         chatPath: { pathname: isEmbedded ? '/embed' : '/', search },
         privacyPath: { pathname: '/privacy' as const, search }
      }),
      [search]
   );
}
